// Categorie V2 ordering helpers (shared by Dashboard, Scadenze).
export function buildCatMap(cats) {
  const m = {};
  (cats || []).forEach((c) => {
    m[c.name] = { priority: !!c.priority, order: c.order ?? 9999 };
  });
  return m;
}

// Overdue: prioritized categories first (in configured order), then by due date;
// remaining (normal) categories after, ordered by due date only.
export function sortOverdue(items, catMap) {
  const rank = (d) => {
    const info = (catMap && catMap[d.category]) || { priority: false, order: 9999 };
    return info.priority ? [0, info.order] : [1, 0];
  };
  return [...(items || [])].sort((a, b) => {
    const ra = rank(a), rb = rank(b);
    if (ra[0] !== rb[0]) return ra[0] - rb[0];
    if (ra[1] !== rb[1]) return ra[1] - rb[1];
    return String(a.due_date).localeCompare(String(b.due_date));
  });
}

// Upcoming: purely by nearest due date (priority must NOT hide a sooner normal one).
export function sortUpcoming(items) {
  return [...(items || [])].sort((a, b) => String(a.due_date).localeCompare(String(b.due_date)));
}
